import request, {Method, roomUrl} from '@/plugins/request.js';
import {buyerUrl, getRequestWithNoToken, postRequestWithNoToken} from '../plugins/request';
export function getStoreListByRoom (params) {
  return request({
    url: `${roomUrl}/room/getStore`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}

export function getHouseTypeList (params) {
  return request({
    url: `${roomUrl}/room/getHouseTypeList`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}

export function getHouseTypeInfo (params) {
  return request({
    url: `${roomUrl}/room/getHouseTypeInfo`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}

export function editCollection (params) {
  return request({
    url: `${roomUrl}/room/editCollection`,
    method: Method.POST,
    needToken: false,
    data: params
    // headers: {'Content-Type': 'application/json'},
  });
}

export function getCollection (params) {
  return request({
    url: `${roomUrl}/room/getCollection`,
    method: Method.GET,
    needToken: false,
    params
  });
}

export function getMatch (params) {
  return request({
    url: `${roomUrl}/room/getMatch`,
    method: Method.GET,
    needToken: false,
    params
  });
}
export function syncOrder (params) {
  return request({
    url: `${roomUrl}/room/syncOrder`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}

/**
 * 创建订房交易
 */
export function createRoomOrder (params) {
  return request({
    url: `${buyerUrl}/buyer/orders/create/roomOrder`,
    method: Method.POST,
    needToken: true,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}
export function findOrderInfo (params) {
  return request({
    url: `${roomUrl}/room/findOrderInfo?orderNumber=` + params.orderNumber,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}
export function getOrderDeductionRatio (params) {
  return request({
    url: `${roomUrl}/room/getOrderDeductionRatio?orderNumber=` + params.orderNumber,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'}
  });
}
export function getHouseType (params) {
  return request({
    url: `${roomUrl}/room/getHouseType/${params}`,
    method: Method.GET,
    needToken: false,
    params,
    headers: {'Content-Type': 'application/json'}
  });
}

/**
 * 获取房型列表
 * @returns {AxiosPromise}
 *
 storeId,state,pageNum,pageSize
 */
export function houseTypePageList (params) {
  return request({
    url: `${roomUrl}/room/houseTypePageList`,
    method: Method.GET,
    message: false,
    params
  });
}

// export function getStoreListByRoom (params) {
//   return postRequestWithNoToken(`${roomUrl}/room/getStore`, params)
// }
// export function getHouseType(params) {
//   return getRequestWithNoToken(`${roomUrl}/room/getHouseType/${params}`,null)
// }



// WEBPACK FOOTER //
// ./src/api/room.js